import { compose } from 'lodash/fp'
import React from 'react'
import FormElement from '../FormElement'
import { IFormElementProps } from '../FormElement/FormInput'
import withReduxForm from '../withReduxForm'
import Radio from './Radio'
import Selected from './Selected'
import withRedux from './withRedux'

function CustomRadio(
  C: React.ComponentType<any>,
): React.ComponentType<IRadioProps> {
  return FormElement(Radio(C))
}

function CustomReduxRadio(
  C: React.ComponentType<any>,
): React.ComponentType<IRadioProps> {
  return compose(
    withReduxForm,
    withRedux,
  )(CustomRadio(C))
}

const RadioField: React.ComponentType<IRadioProps> = CustomRadio(Selected)
const ReduxRadioField: React.ComponentType<IRadioProps> = CustomReduxRadio(
  Selected,
)

export default ReduxRadioField
export { RadioField, CustomRadio, CustomReduxRadio }

export interface IRadioProps extends IFormElementProps {
  temporaryValue?: any
  inputRef?: React.RefObject<HTMLInputElement>
}
